module.exports = __webpack_public_path__ + "png/checkbox-check.png?abfac42572f3f233eba1d57a2453626e";